import { buildAttributesFilterTypes } from './filterHelper';

export const CONTACT_ATTRIBUTE_MODEL = 'contact_attribute';

/**
 * Contact custom attributes offered by the conversation filter, grouped as "Contact attributes". The condition
 * row finds a type by its key, so a contact attribute whose key the conversation already uses (a standard
 * attribute or a conversation custom attribute) is left out; it stays filterable on the Contacts screen.
 * @param {Array} contactAttributes - Contact custom attributes (attributes/getContactAttributes)
 * @param {Function} getOperatorTypes - From useOperators
 * @param {string[]} takenKeys - Keys of the conversation custom attributes
 * @returns {Array} Filter types
 */
export const buildContactAttributeFilterTypes = (
  contactAttributes,
  getOperatorTypes,
  takenKeys
) =>
  buildAttributesFilterTypes(
    contactAttributes,
    getOperatorTypes,
    'conversation'
  )
    .filter(type => !takenKeys.includes(type.attributeKey))
    .map(type => ({
      ...type,
      attributeModel: 'contactAttributes',
      customAttributeType: CONTACT_ATTRIBUTE_MODEL,
    }));

/**
 * Stamps each condition with where its attribute lives ('contact_attribute' or ''), so the server and the live
 * list read the contact of the conversation when the attribute is the contact's.
 * @param {Array} filters - Conditions in camelCase, as the filter rows hold them
 * @param {Array} filterTypes - Filter types of the conversation filter
 * @returns {Array} New conditions
 */
export const withCustomAttributeType = (filters, filterTypes) =>
  filters.map(filter => ({
    ...filter,
    customAttributeType:
      filterTypes.find(type => type.attributeKey === filter.attributeKey)
        ?.customAttributeType ?? '',
  }));
